// eslint-disable-next-line no-restricted-imports
import { css } from "@emotion/react";

import { UNSAFE_media } from "@atlaskit/primitives/responsive";
import { token } from "@atlaskit/tokens";

export const displayNone = css`
    ${UNSAFE_media.below.sm} {
        display: none;
    }
`;

export const searchIconStyle = css`
    background: transparent;
    border: 0;
    cursor: pointer;
    padding: 0;

    &:hover {
        svg {
            background-color: #dfe1e5;
        }
    }

    svg {
        color: #64686f;
        border-radius: 50%;
        height: auto;
        padding: 5px;
        width: 32px;

        ${UNSAFE_media.below.md} {
            width: 50px;
        }
    }
`;

export const searchMainContainerStyle = css`
    top: 100%;
    left: ${token("space.0")};
    background-color: #f4f5f7;
    line-height: ${token("space.300")};
    position: absolute;
    width: 100%;
    z-index: 11;
    border-bottom: 0.5px solid #b3bac5;
`;

export const searchContainerStyle = css`
    padding-top: ${token("space.150")};
    text-align: center;
    margin: ${token("space.0")} auto;

    ${UNSAFE_media.below.md} {
        padding-top: 0;
        width: 100%;
    }
`;

export const searchInputContainerStyle = css`
    display: inline-block;
    margin-right: ${token("space.100")};
    text-align: left;
    width: calc(66.66666% - 91px);
    ${UNSAFE_media.below.md} {
        div label {
            display: none;
        }
        width: calc(100% - 60px);
    }
`;

export const searchFormStyle = css`
    line-height: ${token("space.300")};
    max-width: 1200px;
    margin: 0 auto;
    padding: 5px 20px 24px 20px;
    position: relative;

    label {
        margin-left: 0;
        font-weight: 400;
        font-size: 0.875rem; // 14px
        margin-bottom: ${token("space.050")};
        display: block;
    }
    ${UNSAFE_media.below.md} {
        padding: ${token("space.200")} ${token("space.250")};
        text-align: center;
    }
`;

export const closePanelIconContainerStyle = css`
    background: transparent;
    border: 0;
    cursor: pointer;
    display: flex;
    padding: 0;
    height: ${token("space.200")};
    position: absolute;
    right: ${token("space.250")};
    width: ${token("space.200")};
    top: ${token("space.200")};

    ${UNSAFE_media.below.md} {
        background: rgba(216, 216, 216, 0.6);
        height: 100vh;
        left: 0;
        top: 100%;
        width: 100%;

        > svg {
            display: none;
        }
    }
`;

export const searchIconButtonStyle = css`
    background-color: #0052cc;
    background-size: ${token("space.200")};
    border: 1px solid #0052cc;
    border-radius: ${token("space.050")};
    cursor: pointer;
    height: ${token("space.400")};
    vertical-align: bottom;
    color: transparent;
    max-width: ${token("space.500")};
    padding: ${token("space.0")} ${token("space.100")};
    margin-bottom: ${token("space.075")};

    svg {
        color: #ffffff;
    }
    &:visited {
        color: #f4f5f7;
    }

    &:hover,
    &:active {
        background-color: #0049b0;
        border: 1px solid #0049b0;
    }
`;

export const pageBlurCss = css`
    background: rgba(216, 216, 216, 0.6);
    border: 0;
    display: block;
    height: 100vh;
    left: 0;
    position: absolute;
    top: 100%;
    width: 100%;
    z-index: 1;
`;
